import { IOrder } from "../../types/IOrder";
import QRCode from "react-qr-code";
import { formatDate, getShortId } from "../../utils/commonHelpers";
import { isEmpty } from "lodash";
import { IOrderSource } from "../../types/IOrderSource";
import moment from "moment";

const OrderReceipt = ({
  order,
  orderSource,
  inhouseReceiptOnly,
}: {
  order: IOrder;
  orderSource: IOrderSource;
  inhouseReceiptOnly: boolean;
}) => {
  console.log(">>order: ", order);
  const takeawayLabel = order.is_takeaway_order ? "TAKEAWAY " : "DINEIN ";
  const anotherReceiptOrderItems = order.order_items.filter(
    (orderItem) => orderItem.item.requires_extra_receipt,
  );

  const orderLabel = order.source_identifier
    ? `${orderSource.name}-${order.source_identifier}`.toUpperCase()
    : `${order.order_number}-${takeawayLabel}`;

  return (
    <div
      id="order-receipt-container"
      style={{ fontSize: 13, fontFamily: "sans-serif" }}
    >
      {!inhouseReceiptOnly && (
        <div className="customer-receipt">
          <div style={{ textAlign: "center" }}>
            <img
              alt="splash-logo"
              src="/receipt-logo.png"
              style={{ width: "40%" }}
            />
            <br />
            {
              "-------------------------------------------------------------------------------"
            }

            <div style={{ fontSize: 15 }}>
              <strong>{orderLabel}</strong>
            </div>
            {
              "-------------------------------------------------------------------------------"
            }
            <div style={{ textAlign: "left" }}>
              <span>
                <strong>Order ID: </strong>
                {getShortId(order.id)}
              </span>
              <br />

              <span>
                <strong>Address: </strong>Shop#61, Canning Rd, Saddar,
                Rawalpindi.
              </span>

              <br />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  <strong>Date: </strong>
                  {moment(order.created_at).format("DD-MMMM-YYYY hh:mm A")}
                </span>
                <span>
                  <strong>NTN: </strong>F251106-6
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  <strong>POS ID: </strong>192317
                </span>
                <span>
                  <strong>Payment Mode: </strong>
                  {order.payment_mode}
                </span>
              </div>

              {
                "-------------------------------------------------------------------------------"
              }
            </div>
          </div>

          <table
            style={{
              fontSize: "inherit",
              borderCollapse: "collapse",
            }}
            width={"100%"}
          >
            <tr>
              <th>Qty</th>
              <th>Product Name</th>
              <th>Unit Price</th>
              <th>Total Price WT</th>
            </tr>
            {order.order_items.map((orderItem, index) => {
              const itemName = orderItem.item.name;
              return (
                <tr
                  key={itemName}
                  style={{
                    borderTop: "dashed 1px black",
                  }}
                >
                  <td
                    style={{
                      paddingTop: 3,
                      paddingBottom: 3,
                    }}
                  >
                    {orderItem.quantity}
                  </td>
                  <td width={"38%"}>
                    {orderItem.item.size} {itemName}
                  </td>
                  <td align="right">
                    {orderItem.total_price_without_gst.toFixed(2)}
                  </td>
                  <td align="right">{orderItem.total_price}</td>
                </tr>
              );
            })}
          </table>
          {
            "-------------------------------------------------------------------------------"
          }
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>
                <strong>Amount Excl. Sales Tax</strong>
              </span>
              <span>{order.price_without_gst.toFixed(2)}</span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>
                <strong>Sales Tax ({order.gst_rate}%)</strong>
              </span>
              <span>{order.gst_amount.toFixed(2)}</span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>
                <strong>Amount Incl. Sales Tax</strong>
              </span>
              <span>{order.total}</span>
            </div>
          </div>
          {
            "-------------------------------------------------------------------------------"
          }
          {order.gst_invoice_id && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <span>
                  <strong>PRA E-Invoice number:</strong>
                </span>
                <br />
                <span>{order.gst_invoice_id}</span>
              </div>
              <QRCode value={order.gst_invoice_id} size={65} />
              <div />
            </div>
          )}
        </div>
      )}

      {/* anotherReceiptOrderItems inhouse receipt */}
      {isEmpty(anotherReceiptOrderItems) ? null : (
        <div>
          <div style={{ pageBreakBefore: "always" }} />

          <div style={{ textAlign: "center" }}>
            <strong>{orderLabel}</strong>
          </div>
          {
            "-------------------------------------------------------------------------------"
          }
          <div>
            <span>
              <strong>Date & Time: </strong>
              {formatDate(order.created_at)}
            </span>
            <br />
            {
              "-------------------------------------------------------------------------------"
            }
            <br />

            <table
              style={{ fontSize: "inherit", borderCollapse: "collapse" }}
              width={"100%"}
            >
              {anotherReceiptOrderItems.map((orderItem, index) => {
                const itemName = orderItem.item.name;
                return (
                  <tr
                    key={itemName}
                    style={{
                      ...(index > 0
                        ? {
                            borderTop: "dashed 1px black",
                          }
                        : {}),
                    }}
                  >
                    <td
                      align="left"
                      width={"77%"}
                      style={{
                        paddingTop: 3,
                        paddingBottom: 3,
                      }}
                    >
                      {orderItem.item.size} {itemName}
                    </td>
                    <td width={"3%"} />
                    <td align="left" width={"20%"}>
                      {orderItem.quantity}
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderReceipt;
